import { createContext } from 'react';

const statusContext = createContext();

export default statusContext;